import { CalendarCheckIcon, ClipboardCheckIcon, GraduationCapIcon, ImageIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  purpose?: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Kit de 50 Checklists y Formularios de Yacimientos de Hidrocarburos',
    description: 'Una colección de 50 herramientas listas para utilizar y adaptar en el aula o laboratorio.',
    items: [
      'Fichas de caracterización geológica',
      'Relevamientos de propiedades petrofísicas',
      'Evaluación de prospectos exploratorios',
      'Análisis de trampas geológicas',
      'Registro de información de pozos',
      'Evaluación de recursos',
      'Planificación de desarrollo',
      'Seguimiento de producción',
      'Análisis de yacimientos argentinos',
      'Matriz de decisiones exploratorias',
      'Gestión de incertidumbre',
      'Integración de información técnica',
    ],
    purpose: 'evaluar, documentar y analizar de forma sistemática',
    value: '$16.000 ARS',
    icon: ListChecksIcon,
  },
  {
    number: '02',
    title: 'Kit de Evaluaciones, Rúbricas y Exámenes de Yacimientos de Hidrocarburos',
    description: 'Un sistema completo para evaluar los aprendizajes en yacimientos, con distintos formatos y niveles de complejidad.',
    items: [
      'Evaluaciones diagnósticas',
      'Parciales y recuperatorios',
      'Examen integrador',
      'Banco de preguntas',
      'Rúbricas de evaluación',
      'Autoevaluaciones',
      'Herramientas de corrección',
      'Respuestas orientativas',
      'Criterios de competencia',
      'Evaluación de proyectos',
    ],
    purpose: 'evaluar de forma integral sin crear cada instrumento',
    value: '$15.000 ARS',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: 'Banco de 150 Actividades Prácticas de Yacimientos de Hidrocarburos',
    description: 'Una colección de 150 propuestas listas para implementar durante todo el año lectivo.',
    items: [
      'Análisis visual de estructuras geológicas',
      'Detección de trampas en mapas',
      'Debates sobre exploración',
      'Desafíos de resolución de problemas',
      'Actividades grupales',
      'Ejercicios de aplicación',
      'Juegos pedagógicos',
      'Estudios de casos',
      'Investigaciones temáticas',
      'Análisis de cuencas argentinas',
    ],
    purpose: 'tener siempre una actividad disponible sin empezar de cero',
    value: '$14.000 ARS',
    icon: GraduationCapIcon,
  },
  {
    number: '04',
    title: 'Planificación Anual 2026 + Cronograma Docente de Yacimientos de Hidrocarburos',
    description: 'Un modelo completo para organizar el ciclo lectivo de principio a fin.',
    items: [
      'Planificación anual integrada',
      'Distribución mensual de contenidos',
      'Planificación semanal',
      'Unidades temáticas',
      'Evaluaciones programadas',
      'Proyectos integradores',
      'Fechas de actividades',
      'Seguimiento de competencias',
      'Cronograma de revisión',
      'Conexión con realidad argentina',
    ],
    purpose: 'cerrar tu año lectivo en horas, no en semanas',
    value: '$12.000 ARS',
    icon: CalendarCheckIcon,
  },
  {
    number: '05',
    title: 'Mega Kit Visual de Yacimientos de Hidrocarburos — 100 Láminas, Infografías y Carteles Imprimibles',
    description:
      'Un conjunto de 100 recursos visuales listos para imprimir, plastificar y colocar en aulas y laboratorios.',
    items: [
      'Ciclo de vida de un yacimiento',
      'Sistemas petroleros',
      'Tipos de trampas geológicas',
      'Cuencas argentinas',
      'Propiedades de rocas',
      'Porosidad y permeabilidad',
      'Formación de hidrocarburos',
      'Migración de fluidos',
      'Cuencas sedimentarias',
      'Yacimientos convencionales',
      'Vaca Muerta y no convencionales',
      'Procesos de exploración',
      'Evaluación de recursos',
      'Desarrollo de campos',
      'Perfiles estratigráficos',
      'Carteles educativos',
      'Cronología geológica',
    ],
    purpose: 'proyectar, imprimir y señalizar cada espacio de aprendizaje',
    value: '$13.000 ARS',
    icon: ImageIcon,
    wide: true,
  },
];
